import { MarketStatusEnum } from '@modules/alpaca-module/market-status/enums/market-status.enum'
import { ImageInterface } from '@shared/interfaces/image.interface'

export const IconsByMarketStatusMap: Map<MarketStatusEnum | null, ImageInterface> = new Map([
	[
		MarketStatusEnum.preMarket,
		{ lightUrl: '/images/icons/sunrise.svg', darkUrl: '/images/icons/sunrise.svg', alt: 'sunrise' },
	],
	[
		MarketStatusEnum.postMarket,
		{ lightUrl: '/images/icons/moon.svg', darkUrl: '/images/icons/moon.svg', alt: 'moon' },
	],
	[
		MarketStatusEnum.marketClose,
		{ lightUrl: '/images/icons/moon.svg', darkUrl: '/images/icons/moon.svg', alt: 'moon' },
	],
	[
		MarketStatusEnum.marketOpen,
		{
			lightUrl: '/images/icons/bell-success.svg',
			darkUrl: '/images/icons/bell-success.svg',
			alt: 'clock-fading',
		},
	],
])
